import { EGuardEntityName, ITableColumn } from '~/core/models'
import { forecastPercentNumber } from '~/utils/index'

export const SECTOR_COLUMNS: ITableColumn[] = [
  {
    name: 'sector',
    key: 'sector',
    isTotalColumn: true,
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesBySector.table.sector',
  },
  {
    name: 'epsWeBeatThem',
    key: 'epsWeBeatThem',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesBySector.table.epsWeBeatThem',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'revWeBeatThem',
    key: 'revWeBeatThem',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesBySector.table.revWeBeatThem',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'epsErrorReduction',
    key: 'epsErrorReduction',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesBySector.table.epsErrorReduction',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'revErrorReduction',
    key: 'revErrorReduction',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesBySector.table.revErrorReduction',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'companyCount',
    key: 'companyCount',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesBySector.table.companyCount',
    classes: { 'text-center': true, 'no-wrap': true },
  },
]
